import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from "prop-types";
import bg from "../../assets/images/HeaderDocument.jpg";
import "./base.css";

const Contact_C2_C4 = ({ pdfExportComponent, data, company, company2 }) => {
  // date_day
  // date_month
  // date_year
  // personal_info_name
  // personal_info_age
  // personal_info_house_No
  // personal_info_village_No
  // personal_info_lane
  // personal_info_road
  // personal_info_sub_district
  // personal_info_district
  // personal_info_province
  // personal_info_phone_number
  // detail_position
  // detail_start_date_day
  // detail_start_date_month
  // detail_start_date_year
  // detail_salary
  // detail_salary_word
  return (
    <>
      <div>
        <div id="document-box" className="documents">
          <PDFExport
            ref={pdfExportComponent}
            fileName={`สัญญาว่าจ้างทำงานสำนักงานใหญ่ - ${data.personal_info_name}`}
            forcePageBreak=".page-break"
          >
            <div id="page1" style={{ position: "absolute", top: "0%" }}>
              <div>
                <img
                  id="background"
                  src={bg}
                  alt="bg"
                  style={{
                    width: "800px",
                    height: "auto",
                    top: "0%",
                    zIndex: -5,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              </div>
              <div
                id="content"
                style={{
                  fontFamily: "THSarabun",
                  zIndex: 2,
                }}
              >
                <div
                  id="header"
                  className="text-with-bold "
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    //26px
                    top: "140px",
                    right: "47px",
                    fontSize: "15.5px",
                    width: "705px",
                    fontFamily: "THSarabun",
                    letterSpacing: 0.14,
                    textAlign: "center",
                  }}
                >
                  <b className="docs-font-bold">สัญญาว่าจ้างทำงาน</b>
                </div>
                <div
                  id="date"
                  className="docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "180px",
                    right: "50px",
                    fontSize: "15.5px",
                    // fontFamily: "angsaLight",
                    width: "200px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                  }}
                >
                  ทำที่ บริษัท {company?.name_th}
                  <br />
                  วันที่…..…..….เดือน....……...….....พ.ศ. ………….
                </div>
                <div
                  id="paragraph1"
                  className="text-with-bold docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "240px",
                    right: "47px",
                    fontSize: "15.35px",
                    width: "705px",
                    letterSpacing: 0.14,
                    textAlign: "justify",
                    lineHeight: "20px",
                  }}
                >
                  สัญญาฉบับนี้ทำขึ้นระหว่าง บริษัท {company?.name_th}&nbsp;
                  สำนักงานตั้งอยู่เลขที่ {company2?.address}&nbsp;
                  ซึ่งต่อไปในสัญญานี้
                  <div className="docs-font">
                    เรียกว่า “ นายจ้าง ” ฝ่ายหนึ่ง กับ
                    ....................................................................................................
                    อายุ ................ ปี อยู่บ้านเลขที่
                    ......................... หมู่ที่ ..................... ซอย
                    ........................................... ถนน
                    ....................................................................
                    ตำบล/แขวง ............................................
                    อำเภอ/เขต ............................................
                    จังหวัด ...................................... โทรศัพท์
                    ............................................
                    ซึ่งต่อไปในสัญญานี้จะเรียกว่า “ลูกจ้าง” อีกฝ่ายหนึ่ง
                    <br />
                    ทั้งสองฝ่ายตกลงทำสัญญานี้ขึ้น มีรายละเอียดดังต่อไปนี้
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 1.
                    นายจ้างตกลงจ้างและลูกจ้างตกลงรับจ้างทำงานให้กับนายจ้างในตำแหน่ง
                    ...........................................................................................................................
                    เริ่มตั้งแต่วันที่ ............................ เดือน
                    ............................ พ.ศ.
                    ............................ โดยตกลงจ่ายค่าตอบแทน (ค่าจ้าง)
                    ในอัตราเดือนละ
                    ................................................ บาท (
                    ........................................................................................................................
                    ) ทุกวันที่ 30 ของเดือน
                    โดยจ่ายเงินผ่านบัญชีของธนาคารไทยพาณิชย์ จำกัด (มหาชน)
                    (อัตราค่าจ้างถือเป็นความลับเฉพาะบุคคลระหว่างนายจ้างกับลูกจ้างเท่านั้น
                    ไม่อนุญาตให้เปิดเผยต่อบุคคลอื่น) โดยพนักงานต้องเป็นผู้มี
                    หน้าที่ชำระภาษีเงินได้ เงินประกันสังคม
                    และเงินอื่นใดตามที่กฎหมายกำหนด
                    ซึ่งบริษัทจะทำการหักจากเงินค่าจ้างของพนักงาน ณ
                    ที่จ่ายทุกครั้งในวันจ่ายค่าจ้าง
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 2.
                    คู่สัญญาทั้งสองฝ่ายตกลงกันว่าภายในระยะเวลา 119 วัน
                    นับจากวันที่ลูกจ้างเริ่มปฏิบัติงานให้ถือว่าเป็นระยะทดลองงาน
                    ในระหว่างระยะเวลาดังกล่าวหาก ผลการปฏิบัติงาน ความประพฤติ
                    ทัศนคติและสุขภาพของลูกจ้างไม่ผ่านหลักเกณฑ์การประเมินของนายจ้าง
                    นายจ้างขอสงวนสิทธิในการเลิกจ้างโดยไม่จ่ายเงินค่าชดเชยใดๆทั้งสิ้น
                    นอกจากนี้กรณีที่ผ่านการทดลองงานแล้วแต่ทางบริษัท ฯ
                    มีความจำเป็นต้องเลิกจ้างก็สามารถเลิกจ้างได้
                    หากกรณีที่การเลิกจ้างโดยไม่ใช่ความผิดของลูกจ้าง
                    นายจ้างจะจ่ายค่าชดเชยให้ตามที่กฎหมายแรงงานกำหนด
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 3.
                    ลูกจ้างตกลงว่าจะทำงานกับนายจ้างตามที่กำหนดในสัญญานี้
                    โดยจะปฏิบัติตามระเบียบข้อบังคับของบริษัทอย่างเคร่งครัดและไม่ทำให้นายจ้างได้รับความเสียหาย
                    หากลูกจ้างปฏิบัติผิดสัญญาฉบับนี้
                    ลูกจ้างตกลงชดใช้ค่าเสียหายเป็นเงินจำนวน 3
                    เท่าของอัตราค่าจ้างเดือนสุดท้ายเต็มเดือนที่เกิดจากผลของการผิดสัญญาทั้งสิ้น
                    โดยจะชำระให้เสร็จสิ้นภายในเวลาที่นายจ้างกำหนด
                    <br />
                    <b className="docs-font-bold">
                      &nbsp;&emsp;&emsp;&emsp;ในกรณีที่ลูกจ้างทุจริตต่อหน้าที่
                      เช่น ยักยอกทรัพย์ ลักทรัพย์ หรือทำให้ทรัพย์สินของทางบริษัท
                      ฯ เสียหาย ลูกจ้างจะต้องชำระค่าเสียหายเป็น
                      <u className="docs-font-bold">จำนวน 3 เท่า</u>
                      ของมูลค่าทรัพย์สินที่เสียหายนั้น ๆ
                    </b>
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 4.
                    หากลูกจ้างลาออกจากงานโดยไม่ยื่นใบลาออกตามกฎระเบียบข้อบังคับของบริษัทว่าด้วยการพ้นสภาพการจ้างงาน(ลาออก)
                    ลูกจ้างยินยอมรับผิดชอบความเสียหายเป็นเงิน
                    <u className="docs-font-bold">จำนวน 3 เท่า</u>
                    ของอัตราค่าจ้างเดือนสุดท้ายเต็มเดือนให้แก่นายจ้าง
                    พร้อมดอกเบี้ยในอัตราร้อยละ 15 ต่อปี
                    โดยจะชำระให้เสร็จสิ้นภายในเวลาที่นายจ้างกำหนด
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 5.
                    การระบุตำแหน่งของลูกจ้างตามสัญญาข้อ 1. นั้น
                    เป็นเพียงการกำหนดตำแหน่งในเบื้องต้นเท่านั้นหลังจากที่ลูกจ้างได้เข้าทำงานแล้ว
                    โดยที่ลูกจ้างยินยอมให้นายจ้างเปลี่ยนแปลง
                    โยกย้ายตำแหน่งหน้าที่
                    เปลี่ยนแปลงเวลาทำงานหรือสถานที่ทำงานของลูกจ้างได้
                    ซึ่งนายจ้างจะแจ้งให้ลูกจ้างทราบล่วงหน้าอย่างน้อย 30 วัน
                    หากลูกจ้างไม่ยินยอมโดยไม่มีเหตุผลอันสมควร
                    ถือว่าลูกจ้างไม่ประสงค์จะทำงานให้กับนายจ้างอีกต่อไป
                    โดยนายจ้างจะจ่ายค่าจ้างและค่าชดเชยตามที่กำหนดไว้ในกฎหมายแรงงาน
                    และลูกจ้างต้องรับผิดความเสียหายที่เกิดขึ้นให้แก่บริษัทตามข้อ
                    3.
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ในกรณีที่ต้องทำงานอันมีลักษณะเป็นการเร่งด่วนต่อเนื่องกันและจำเป็นต้องทำงานล่วงเวลา
                    ลูกจ้างยินดีที่จะทำงานตามเวลาที่นายจ้างร้องขอ
                    โดยนายจ้างจะจ่ายค่าล่วงเวลาให้แก่ลูกจ้างตามที่กฎหมายกำหนด
                    หากลูกจ้างไม่ยอมทำงานล่วงเวลาโดยไม่มีเหตุอันสมควร
                    อันเป็นเหตุให้บริษัทได้รับความเสียหาย
                    ลูกจ้างยินยอมรับผิดชอบความเสียหาย เป็นเงิน
                    <u className="docs-font-bold">จำนวน 3 เท่า</u>
                    ของอัตราค่าจ้างเดือนสุดท้ายเต็มเดือนให้แก่นายจ้าง
                    พร้อมดอกเบี้ยในอัตราร้อยละ 15 ต่อปี
                    โดยจะชำระให้เสร็จสิ้นภายในเวลาที่นายจ้างกำหนด
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 6.
                    ลูกจ้างตกลงและยอมรับว่าการวางแผนการบริหารงาน วางแผนการค้า
                    หรือการคิดค้นเทคนิควิธีการต่าง ๆ
                    ไม่ว่าในทางการค้าหรือทางอื่นใดเพื่อประโยชน์ใดๆ
                    ที่มีต่อนายจ้างไม่ว่าจะคิดโดยนายจ้างหรือลูกจ้างหรือลูกจ้างคนอื่นๆ
                    ของนายจ้างก็ตามให้ถือว่าแนวคิดวิธีการหรือหลักการดังกล่าวนั้นเป็นทรัพย์สินทางปัญญาของนายจ้างซึ่งลูกจ้างจะนำไปให้บุคคลอื่นใช้หรือแนะนำให้บุคคลอื่นใช้หรือกระทำด้วยประการใดๆ
                    ก็ตามที่อาจทำให้นายจ้างได้รับความเสียหาย เสียประโยชน์
                    ไม่ได้โดยเด็ดขาด
                    หากฝ่าฝืนถือว่าลูกจ้างละเมิดทรัพย์สินทางปัญญาของนายจ้างหรือละเมิดลิขสิทธิ์ของนายจ้าง
                    นายจ้างสามารถดำเนินคดีทั้งทางแพ่งและทางอาญากับลูกจ้างได้ทันทีแม้ว่าภายหลังลูกจ้างจะได้ออกจากการเป็นพนักงานของนายจ้างหรือผู้ว่าจ้างได้เลิกจ้างแล้วก็ตาม
                    เว้นแต่นายจ้างจะอนุญาตให้ลูกจ้างนำไปใช้
                    นำไปเผยแพร่หรือนำไปให้บุคคลอื่นใช้เป็นลายลักษณ์อักษรเท่านั้น
                    นอกจากนี้ลูกจ้างจะไม่นำงานที่ละเมิดทรัพย์สินทางปัญญาของบุคคลอื่นเข้ามาทำงานตามสัญญานี้ด้วย
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 7.
                    ไม่ว่าลูกจ้างจะยังทำงานกับนายจ้างอยู่หรือไม่ก็ตาม
                    ลูกจ้างตกลงจะไม่นำความลับทางการค้า ข้อมูลความลับทางธุรกิจ
                    ข้อมูลที่หากเปิดเผยแล้วจะทำให้นายจ้างเสียประโยชน์และความสามารถในการแข่งขันกับบุคคลอื่นหรือข้อมูลใดๆ
                    ของนายจ้างไปเปิดเผยโดยเด็ดขาด
                    ไม่ว่าบุคคลหรือนิติบุคคลนั้นจะเป็นคู่แข่งทางการค้ากับบริษัทหรือไม่ก็ตาม
                    หากลูกจ้างฝ่าฝืน
                    ลูกจ้างตกลงรับผิดชอบต่อการกระทำที่เกิดขึ้นทั้งสิ้นและลูกจ้างยินดีให้นายจ้างดำเนินคดีตามกฎหมายได้ทันที
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;นอกจากนี้ลูกจ้างยินยอมรับผิดชอบในความเสียหายเป็นเงินจำนวน
                    3
                    เท่าของอัตราค่าจ้างเดือนสุดท้ายเต็มเดือนให้แก่นายจ้างพร้อมดอกเบี้ยในอัตราร้อยละ15
                    ต่อปี โดยจะชำระให้เสร็จสิ้นภายในเวลาที่นายจ้างกำหนด
                    <br />
                  </div>
                </div>
              </div>
              <div id="var" className="var">
                {company2.head && (
                  <img
                    src={company2.head}
                    style={{
                      position: "absolute",
                      width: "770px",
                      height: "100px",
                      right: "10px",
                      top: "20px",
                      zIndex: 100,
                      boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                )}
                {company2.foot && (
                  <img
                    src={company2.foot}
                    style={{
                      position: "absolute",
                      width: "770px",
                      height: "70px",
                      right: "10px",
                      top: "1060px",
                      zIndex: 100,
                      boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                )}
                <div
                  id="date_day"
                  className="date day docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "197.5px",
                    right: "197px",
                    fontSize: "15.5px",
                    width: "32px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                  }}
                >
                  {data.date_day}
                </div>

                <div
                  id="date_month"
                  className="date month docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "197.5px",
                    right: "119px",
                    fontSize: "15.5px",
                    width: "54px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                  }}
                >
                  {data.date_month}
                </div>

                <div
                  id="date_year"
                  className="date year docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "197.5px",
                    right: "65.25px",
                    fontSize: "15.5px",
                    width: "30px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.date_year}
                </div>

                <div
                  id="personal_info_name"
                  className="personal_info name docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "257.5px",
                    right: "339px",
                    fontSize: "15.5px",
                    width: "260px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_name}
                </div>
                <div
                  id="personal_info_age"
                  className="personal_info age docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "257.5px",
                    right: "270.6px",
                    fontSize: "15.5px",
                    width: "40px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_age}
                </div>

                <div
                  id="personal_info_house_No"
                  className="personal_info house_No docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "257.5px",
                    right: "140px",
                    fontSize: "15.5px",
                    width: "49px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_house_No}
                </div>

                <div
                  id="personal_info_village_No"
                  className="personal_info village_No docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "257.5px",
                    right: "55px",
                    fontSize: "15.5px",
                    width: "40px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_village_No}
                </div>

                <div
                  id="personal_info_lane"
                  className="personal_info lane docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "277.5px",
                    right: "625px",
                    fontSize: "15.5px",
                    width: "107px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_lane}
                </div>

                <div
                  id="personal_info_road"
                  className="personal_info road docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "277.5px",
                    right: "400px",
                    fontSize: "15.5px",
                    width: "180px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_road}
                </div>

                <div
                  id="personal_info_sub_district"
                  className="personal_info sub_district docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "277.5px",
                    right: "230px",
                    fontSize: "15.5px",
                    width: "94px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_sub_district}
                </div>

                <div
                  id="personal_info_district"
                  className="personal_info district docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "277.5px",
                    right: "57px",
                    fontSize: "15.5px",
                    width: "94px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_district}
                </div>

                <div
                  id="personal_info_province"
                  className="personal_info province docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "297.5px",
                    right: "625px",
                    fontSize: "15.5px",
                    width: "96px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_province}
                </div>

                <div
                  id="personal_info_phone_number"
                  className="personal_info phone_number docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "297.5px",
                    right: "460px",
                    fontSize: "15.5px",
                    width: "110px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.personal_info_phone_number}
                </div>

                <div
                  id="detail_position"
                  className="detail position docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top:
                      data?.detail_position?.length >= 60
                        ? "340.5px"
                        : "337.5px",
                    right: "85px",
                    fontSize:
                      data?.detail_position?.length >= 60 ? "8px" : "15.5px",
                    width: "254px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "red"
                  }}
                >
                  {data.detail_position}
                </div>

                <div
                  id="detail_start_date_day"
                  className="detail start_date_day docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "357.5px",
                    right: "644.5px",
                    fontSize: "15.5px",
                    width: "23px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "green"
                  }}
                >
                  {data.detail_start_date_day}
                </div>

                <div
                  id="detail_start_date_month"
                  className="detail start_date_month docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "357.5px",
                    right: "525.5px",
                    fontSize: "15.5px",
                    width: "51px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "pink"
                  }}
                >
                  {data.detail_start_date_month}
                </div>

                <div
                  id="detail_start_date_year"
                  className="detail start_date_year docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "357.5px",
                    right: "435px",
                    fontSize: "15.5px",
                    width: "35px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "lightblue"
                  }}
                >
                  {data.detail_start_date_year}
                </div>

                <div
                  id="detail_salary"
                  className="detail salary docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "357.5px",
                    right: "95px",
                    fontSize: "15.5px",
                    width: "77px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "gray"
                  }}
                >
                  {data.detail_salary}
                </div>

                <div
                  id="detail_salary_word"
                  className="detail salary_word docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "377.5px",
                    right: "440.5px",
                    fontSize: "15.5px",
                    width: "300px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                    // backgroundColor: "salmon"
                  }}
                >
                  {data.detail_salary_word}
                </div>
              </div>
            </div>
            <div
              id="page2"
              className="page-break"
              style={{ position: "absolute", top: "1150px", right: "0%" }}
            >
              <div>
                <img
                  id="background"
                  src={bg}
                  alt="bg"
                  style={{
                    width: "800px",
                    height: "auto",
                    position: "relative",
                    // top: "1150px",
                    // right: "0%",
                    zIndex: -5,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
                <div
                  id="content"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "0px",
                    fontFamily: "THSarabun",
                    right: "0px",
                  }}
                >
                  <div
                    id="paragraph1"
                    className="docs-font"
                    style={{
                      zIndex: 2,
                      position: "relative",
                      top: "125px",
                      right: "47px",
                      fontSize: "15.35px",
                      width: "705px",
                      letterSpacing: 0.14,
                      textAlign: "justify",
                      lineHeight: "20px",
                    }}
                  >
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 8. ณ
                    วันที่ลูกจ้างตกลงเข้าทำงานกับนายจ้างตามสัญญานี้
                    ลูกจ้างได้ทราบและตระหนักเป็นอย่างดีถึงเรื่องของการที่จะไม่นำความลับทางการค้าหรือข้อมูลใดๆ
                    ของนายจ้าง ตามข้อ 7. ไปเปิดเผยโดยเด็ดขาดอยู่แล้ว
                    รวมถึงรับทราบข้อกำหนดทั้งหมดในสัญญารักษาความลับซึ่งลูกจ้างได้ลงนามพร้อมกับสัญญาฉบับนี้
                    ลูกจ้างจึงขอสัญญาว่า
                    หากลูกจ้างพ้นสภาพจากการเป็นลูกจ้างไปแล้ว ไม่ว่ากรณีใดๆ
                    จะโดยจงใจหรือประมาทเลินเล่อก็ตาม
                    ลูกจ้างจะไม่ส่งมอบเอกสารต่างๆหรือยินยอมให้ข้อมูลข่าวสารต่าง
                    ๆ
                    ล่วงรู้ไปถึงบุคคลหรือนิติบุคคลอื่นที่ประกอบกิจการค้าเช่นเดียวกันหรือคล้ายคลึงกันกับนายจ้าง
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ลูกจ้างตกลงว่าภายในระยะเวลาไม่น้อยกว่า
                    18 เดือน นับจากวันที่สัญญาจ้างสิ้นสุดลง
                    ลูกจ้างจะไม่เข้าเป็นพนักงาน ลูกจ้าง ตัวแทน
                    ที่ปรึกษาหรือเข้าร่วมกับบุคคล องค์กร
                    หรือหน่วยงานใดไม่ว่าจะโดยตรงหรือโดยอ้อม
                    ซึ่งประกอบธุรกิจอันมีลักษณะเหมือนกันหรือคล้ายคลึงกัน
                    หรือเป็นการแข่งขันกับธุรกิจของนายจ้าง ทั้งนี้
                    ลูกจ้างรับทราบเป็นอย่างดีว่าการฝ่าฝืนข้อปฏิบัติตามข้อนี้
                    ไม่ว่าโดยวิธีการใด
                    ถือว่าเป็นการจงใจทำให้นายจ้างได้รับความเสียหายอย่างร้ายแรง
                    ซึ่งลูกจ้างจะต้องชำระเงินค่าเสียหาย
                    รวมถึงค่าใช้จ่ายใดๆให้กับนายจ้างตามจำนวนที่นายจ้างเรียกร้องโดยไม่มีข้อยกเว้น
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 9.
                    ลูกจ้างตกลงจะปฏิบัติตามระเบียบ
                    ข้อบังคับการทำงานของนายจ้างโดยเคร่งครัด รวมทั้งระเบียบใดๆ
                    ที่นายจ้างได้กำหนดขึ้นไม่ว่าจะมีการกำหนดอยู่แล้วในขณะทำสัญญาจ้างหรือมีการแก้ไขเพิ่มเติมในอนาคตก็ตาม
                    เมื่อนายจ้างได้ประกาศให้ลูกจ้างทราบ ณ ที่ทำการของนายจ้างแล้ว
                    ให้ถือว่าลูกจ้างได้รับทราบระเบียบข้อบังคับดังกล่าว
                    และให้ระเบียบ
                    ข้อบังคับของนายจ้างนั้นเป็นส่วนหนึ่งของสัญญาฉบับนี้
                    หากลูกจ้างฝ่าฝืนระเบียบหรือข้อบังคับใดๆ ของนายจ้าง
                    ลูกจ้างตกลงให้นายจ้างดำเนินการตามระเบียบและข้อบังคับที่กำหนดไว้ในนั้น
                    และยินยอมรับผิดชอบในความเสียหายที่เกิดขึ้น
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 10.
                    ค่าเสียหายใดๆที่เกิดจากการผิดสัญญานี้หรือทุจริตต่อหน้าที่ของลูกจ้าง
                    ลูกจ้างยินยอมโดยปราศจากข้อโต้แย้งให้นายจ้างหักจากค่าจ้าง
                    ค่าตอบแทน เงินใดๆที่ลูกจ้างมีสิทธิได้รับจากนายจ้าง
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 11.
                    ในกรณีที่มีการฟ้องร้องบังคับคดีเพราะลูกจ้างประพฤติผิดสัญญา
                    ลูกจ้างต้องชำระค่าทนายความ ค่าติดตามทวงถาม
                    ชำระค่าธรรมเนียมศาลต่าง ๆ ที่นายจ้างต้องเสียไป
                    และให้ใช้ดอกเบี้ยในอัตราร้อยละ 15 ต่อปีในการดำเนินคดีต่าง ๆ
                    ได้
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 12.
                    ในกรณีที่ลูกจ้างพ้นสภาพจากการเป็นพนักงาน (ทุกกรณี)
                    ลูกจ้างต้องส่งมอบทรัพย์สินที่เป็นของบริษัททุกชนิด
                    รวมทั้งเอกสารข้อมูลต่าง ๆ ด้วย และให้ข้อตกลงพิเศษต่างๆ
                    ที่นายจ้างได้ตกลงกับลูกจ้างเป็นอันยกเลิกทันที
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 13.
                    ในกรณีที่นายจ้างมีการเปลี่ยนแปลงชื่อบริษัทฯ ขึ้นใหม่
                    และลูกจ้างยังคงรับทำงานให้อยู่ในขณะที่มีการเปลี่ยนแปลงชื่อบริษัทฯ
                    ลูกจ้างไม่ต้องทำสัญญาจ้างขึ้นใหม่ แต่ให้นำบรรดาเอกสารต่าง ๆ
                    ของลูกจ้างที่เกี่ยวข้องกับสัญญาจ้างฉบับนี้มาใช้กับบริษัทที่เปลี่ยนแปลงชื่อใหม่ได้ทันที
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 14.
                    ลูกจ้างจะต้องไม่เข้าไปมีส่วนร่วมกระทำหรือปกปิดการกระทำใดๆ
                    ที่อาจมีความขัดแย้งทางผลประโยชน์กับนายจ้าง
                    หรือทำให้ไม่สามารถปฏิบัติหน้าที่ได้ด้วยความยุติธรรม
                    หรือเข้าไปมีส่วนร่วมในการปกปิดการกระทำผิดกฎหมาย
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 15.
                    ลูกจ้างจะไม่ใช้ข้อมูลของบริษัทที่ได้รับจากการปฏิบัติหน้าที่เพื่อแสวงหาผลประโยชน์แก่ตนเองหรือผู้อื่นโดยมิชอบ
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 16. ลูกจ้างจะไม่กระทำการใดๆ
                    อันเป็นการเรียกร้องหรือรับสิ่งของ
                    หรือผลประโยชน์อื่นใดจากบุคคลอื่นที่มีหน้าที่หรือธุรกิจเกี่ยวข้องกับนายจ้าง
                    เว้นแต่ในโอกาสหรือเทศกาลอันเป็นประเพณีนิยมที่คนทั่วไปพึงปฏิบัติต่อกัน
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 17.
                    ลูกจ้างจะไม่ข้องเกี่ยวกับการคอร์รัปชั่น
                    ในทุกรูปแบบทั้งในทางตรงและทางอ้อม
                    ตลอดจนจะปฏิบัติงานให้สอดคล้องกับกฎหมายที่เกี่ยวข้อง
                    และแสดงความมุ่งมั่นในการต่อต้านคอร์รัปชั่น
                    เพื่อร่วมกันสร้างค่านิยมและความตระหนักในการดำเนินงาน
                    ด้วยความซื่อสัตย์ สุจริต โปร่งใส และปราศจากการคอร์รัปชั่น
                    ให้เป็นวัฒนธรรมขององค์กร
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ข้อ 18.
                    การที่นายจ้างตกลงรับลูกจ้างเข้าทำงานตามสัญญานี้
                    เนื่องมาจากลูกจ้างได้แจ้ง แสดงหลักฐาน หรือให้คำรับรองว่า
                    เป็นผู้มีคุณสมบัติ และมีความสามารถตามที่นายจ้างกำหนดไว้
                    ซึ่งลูกจ้างได้ทราบรายละเอียดต่างๆดีแล้ว
                    ดังนั้นหากปรากฏในภายหลังไม่ว่ากรณีใดๆว่า ลูกจ้างมีคุณสมบัติ
                    หรือความสามารถไม่ตรง หรือไม่เหมาะสมที่ได้แจ้ง แสดงหลักฐาน
                    หรือรับรองไว้ หรือแสดงหลักฐานอันเป็นเท็จ
                    หรือปกปิดข้อความจริงอันอาจทำให้นายจ้างไม่รับเข้าทำงาน
                    ลูกจ้างตกลงให้ถือว่าการกระทำดังกล่าวเป็นการจงใจทำให้นายจ้างได้รับความเสียหาย
                    ซึ่งนายจ้างมีสิทธิเลิกจ้างลูกจ้างได้ทันทีโดยไม่ต้องชำระค่าชดเชยและค่าเสียหายใดๆทั้งสิ้น
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ลูกจ้างยินยอมและตกลงให้นายจ้างเก็บ
                    รวบรวม ใช้ หรือเปิดเผยซึ่งข้อมูลส่วนบุคคลของลูกจ้างได้
                    ทั้งนี้ตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคลกำหนด
                    โดยที่นายจ้างมีสิทธิในการใช้งาน ตรวจสอบ เรียกเพิ่ม
                    ข้อมูลส่วนบุคคลใดๆ ของลูกจ้างได้ตามความจำเป็น
                    และให้ถือว่าเอกสารต่างๆดังกล่าวนั้นเป็นส่วนหนึ่งของสัญญาจ้างด้วย
                    ทั้งนี้หากนายจ้างพบว่าข้อมูลของลูกจ้างไม่เป็นความจริง
                    และข้อมูลที่ได้รับมีผลกระทบต่องานที่ทำ
                    อันอาจทำให้นายจ้างเสียหาย
                    ลูกจ้างยินยอมให้นายจ้างเลิกจ้างได้ทันทีโดยไม่โต้แย้งใดๆ
                    <br />
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;คู่สัญญาทั้งสองฝ่ายได้อ่านข้อความโดยตลอดและเข้าใจข้อความในสัญญานี้ทุกข้อแล้ว
                    จึงได้ลงลายมือชื่อไว้เป็นสำคัญต่อหน้าพยาน
                    <br />
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................นายจ้าง
                    &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................ลูกจ้าง
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;&emsp;(
                    .........................................................................
                    ) &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                    ........................................................................
                    )
                    <br />
                    <br />
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พยาน
                    &nbsp;&nbsp;&nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.........................................................................พยาน
                    <br />
                    &nbsp;&emsp;&emsp;&emsp;&emsp;(
                    .........................................................................
                    ) &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                    ........................................................................
                    )
                  </div>
                </div>
              </div>

              <div id="var" className="var">
              {company2.head && (
                  <img
                    src={company2.head}
                    style={{
                      position: "absolute",
                      width: "770px",
                      height: "100px",
                      right: "10px",
                      top: "20px",
                      zIndex: 100,
                      boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                )}
                {company2.foot && (
                  <img
                    src={company2.foot}
                    style={{
                      position: "absolute",
                      width: "770px",
                      height: "70px",
                      right: "10px",
                      top: "1060px",
                      zIndex: 100,
                      boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                    }}
                  />
                )}
                <div
                  id="personal_info_name2"
                  className="personal_info name2 docs-font"
                  style={{
                    zIndex: 2,
                    position: "absolute",
                    top: "922.5px",
                    right: "145px",
                    fontSize: "15.5px",
                    width: "187px",
                    letterSpacing: 0.14,
                    fontFamily: "THSarabun",
                    textAlign: "center",
                  }}
                >
                  {data.personal_info_name}
                </div>
              </div>
            </div>
          </PDFExport>
        </div>
      </div>
    </>
  );
};

Contact_C2_C4.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object }),
  ]),
};

export default Contact_C2_C4;
